var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stripe-checkout',{ref:"checkoutRef",attrs:{"pk":_vm.publishableKey,"session-id":_vm.sessionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }